export default __webpack_public_path__ + "static/media/contactus-img.1ef5183b.svg";